// src/hooks/useScheduleMap.js
import { makeISO } from '../utils/schedule';
import { useState } from 'react';

export default function useScheduleMap() {
  // { [key: string]: { dateISO, time, iso } }
  const [scheduledMap, setScheduledMap] = useState({});
  const setFor = (key, dateISO, time) =>
    setScheduledMap(prev => ({ ...prev, [key]: { dateISO, time, iso: makeISO(dateISO, time) } }));
  const clearFor = (key) =>
    setScheduledMap(prev => { const p = { ...prev }; delete p[key]; return p; });
  return { scheduledMap, setFor, clearFor };
}